import { SectionHeader } from "@/components/SectionHeader";
import avatar from "@/assets/about/avatar.svg";
import apple from "@/assets/about/logo-apple.svg";
import control4 from "@/assets/about/logo-control4.svg";
import dropbox from "@/assets/about/logo-dropbox.svg";
import eightSleep from "@/assets/about/logo-eight-sleep.svg";
import groupon from "@/assets/about/logo-groupon.svg";
import honeywell from "@/assets/about/logo-honeywell.svg";
import jll from "@/assets/about/logo-jll.svg";
import nest from "@/assets/about/logo-nest.svg";
import schneiderElectric from "@/assets/about/logo-schneider-electric.svg";
import siemens from "@/assets/about/logo-siemens.svg";
import tesla from "@/assets/about/logo-tesla.svg";
import uber from "@/assets/about/logo-uber.svg";
import { cn } from "@/lib/cn";

const BIO_PLACEHOLDER = "One-liner credibility statement goes here on the bio.";

const TEAM = [
  { name: "Yishai Lerner", role: "CEO & Founder", bio: BIO_PLACEHOLDER },
  { name: "Ulf Schwekendiek", role: "CTO & Founder", bio: BIO_PLACEHOLDER },
  { name: "Dan Nurko", role: "VP of Hardware & Founder", bio: BIO_PLACEHOLDER },
  { name: "Bryan Thomas", role: "Head of Operations", bio: BIO_PLACEHOLDER },
  { name: "Greg C", role: "Head of Software", bio: "Ex Dropbox Guy" },
  { name: "Jeff Smith", role: "Head of US Sales", bio: BIO_PLACEHOLDER },
  { name: "Caterine Lopez", role: "Head of LATAM Sales", bio: BIO_PLACEHOLDER },
  { name: "Greg W", role: "Head of Partnerships", bio: BIO_PLACEHOLDER },
];

const LOGOS = [
  { src: jll, alt: "JLL" },
  { src: apple, alt: "Apple" },
  { src: dropbox, alt: "Dropbox" },
  { src: uber, alt: "Uber", wordmark: true },
  { src: nest, alt: "Nest" },
  { src: tesla, alt: "Tesla" },
  { src: siemens, alt: "Siemens", wordmark: true },
  { src: eightSleep, alt: "Eight Sleep" },
  { src: groupon, alt: "Groupon", wordmark: true },
  { src: honeywell, alt: "Honeywell", wordmark: true },
  { src: schneiderElectric, alt: "Schneider Electric" },
  { src: control4, alt: "Control4", wordmark: true },
];

export function AboutTeamSection() {
  return (
    <section id="team" className="px-2 sm:px-4 py-20 md:px-6 md:py-16 lg:pt-32">
      <SectionHeader
        variant="split"
        className="mx-auto max-w-6xl px-6 sm:px-4 md:px-0"
        eyebrow="Meet our team"
        title="The Experience Behind Somo"
        body="Somo brings together leaders with deep experience across technology, hospitality, connected products, engineering, and design. After building and scaling products used by millions, our founders came together around a new challenge: bringing that same level of thoughtfulness and innovation to the technology behind hospitality."
      />
      <ul className="mx-auto mt-12 grid max-w-8xl grid-cols-2 gap-x-4 gap-y-4 md:mt-16 md:grid-cols-3 md:gap-y-10 lg:grid-cols-4">
        {TEAM.map((person) => (
          <li key={person.name} className="flex flex-col gap-4 md:gap-8">
            <div className="flex aspect-square items-center justify-center rounded-card bg-tertiary">
              <img
                loading="lazy"
                decoding="async"
                src={avatar}
                alt=""
                className="w-1/4"
              />
            </div>
            <div className="flex flex-col gap-2 px-4 md:pl-0 md:pr-8">
              <h3 className="card-title text-primary">{person.name}</h3>
              <p className="font-mono text-xs uppercase leading-relaxed tracking-label text-primary">
                {person.role}
              </p>
              <p className="text-sm leading-normal tracking-body text-secondary md:text-base">
                {person.bio}
              </p>
            </div>
          </li>
        ))}
      </ul>
      <ul
        aria-label="Where our team has worked"
        className="mx-auto mt-12 flex max-w-8xl flex-wrap md:mt-16 items-center justify-center gap-x-10 gap-y-6 lg:justify-between"
      >
        {LOGOS.map((logo) => (
          <li key={logo.alt}>
            <img
              loading="lazy"
              decoding="async"
              src={logo.src}
              alt={logo.alt}
              className={cn(
                "w-auto opacity-40",
                "wordmark" in logo ? "h-5" : "h-6",
              )}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
